module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Mesh', {
    attrs: {
      "visible": _vm.visible,
      "vms": _vm.vms,
      "position": _vm.finalPosition,
      "scale": _vm.finalScale,
      "gclick": _vm.gclick,
      "gTS": _vm.gTS
    },
    on: {
      "mesh": function (v) {
        _vm.mesh = v;
      }
    }
  }, [(_vm.ready) ? _c('PlaneGeometry', {
    attrs: {
      "width": _vm.sWidth,
      "height": _vm.sHeight,
      "translate": _vm.finalTranslate,
      "scale": _vm.scale
    }
  }) : _vm._e(), _vm._v(" "), _c('MeshPictureMaterial', {
    attrs: {
      "opacity": 1,
      "color": 0xffffff,
      "image": _vm.link,
      "blending": _vm.blending,
      "depthTest": _vm.depthTest,
      "transparent": _vm.transparent,
      "blendEquation": _vm.blendEquation,
      "blendSrc": _vm.blendSrc,
      "blendDst": _vm.blendDst
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d51ee2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebGL/Custom/ImageMesh.vue
// module id = 606
// module chunks = 0